import * as z from "zod";

export const getDigitalWarehousePreview = {
  name: "getDigitalWarehousePreview" as const,
  input: z.object({}),
  output: z.object({
    products: z.array(
      z.object({
        productId: z.string(),
        merchantLocations: z.array(
          z.object({ locationId: z.string(), locationName: z.string() }),
        ),
      }),
    ),
  }),
};
